import $ from 'Vendor/jquery'
import Logger from 'Vendor/@openmind/litelog'

import Search from '../../search'
import {AddressType, Errors} from "../../const";

const Log = new Logger("StoreLocator/BaiduSearch");

class BaiduSearch extends Search {

  get DefaultOptions() {
    return {};
  }

  // GoogleSearch(...).then((res) => res);

  constructor(provider, element, options) {
    super(provider, element)

    let p = new Promise( (resolve, reject) => {


      const extend = $.extend(true, {}, options || {});

      const input = this.$element[0];
      this.autocomplete = new window.BMap.Autocomplete({
        input,
        extend
      });

      const search=(valueToSearch)=>{
        const map = this.provider.Map.Map;
        new window.BMap.LocalSearch(map,{
          onSearchComplete:(results)=>{

            if(!results)return;

            const result=results.getPoi(0);

            if ( result ) {
              const {point:{lat,lng}} = result;
              const bounds = this.getSearchViewportFromLocation(map, lng, lat);
              this.provider.trigger('change-address', BaiduSearch.getAddressFromResult(result), {
                lat,
                lng,
                bounds,
                _type:  AddressType.Generic
              });
            }
          }
        }).search(valueToSearch);
      }
     /* const $input=$(input);
      let debounce = null;
      $(document).on('keyup',$input,()=>{
        clearTimeout(debounce);
        debounce = setTimeout(()=>{
          search(
              $input.val(),
              true
          )
        }, 2000);
      });*/

      this.autocomplete.addEventListener('onconfirm', (e) => {
        const valueToSearch = BaiduSearch.getAddressFromResult(e.item.value);
        search(valueToSearch);
      });

      resolve(this);

    });

    this.Geocoder=new window.BMap.Geocoder();

    return p;
  }


  static getAddressFromResult(e) {
    const {
      title,
      business,
      city,
      district,
      province,
      postcode,
      street,
      streetNumber
    } = e;
    let ris="";

    if(title){
      ris+=title+" ";
    }
    if(business){
      ris+=business+" ";
    }
    if(city){
      ris+=city+" ";
    }
    if(district){
      ris+=district+" ";
    }
    if(province){
      ris+=province+" ";
    }
    if(postcode){
      ris+=postcode+" ";
    }
    if(street){
      ris+=street+" ";
    }
    if(streetNumber) {
      ris += streetNumber + " ";
    }

    return ris.trim();
  }

  /**
   * @Override
   */
  search(str) {
    return new Promise( (resolve, reject) => {
      // Search address
      new window.BMap.LocalSearch(this.provider.Map.Map,{
        onSearchComplete: (predictions)=>{

            Log.l("Results", predictions);

            // catch error
            predictions = predictions || [];

            let result = [];

            for(let i=0,x=predictions.getNumPois();i<x;i++){

              const prediction=predictions.getPoi(i);

              result.push({
                main: prediction.title,
                other: BaiduSearch.getAddressFromResult(prediction)
              });
            }

            resolve(result);
          }
      }).search(str);
    });

  }

  processOnPlaceChangeResult(placeChangeResult,fallbackObj,clicked,map,isInitialSearch){
    let searchedCountry = "cn";
    let address_text;
    let geolocation = null;
    const locationToPatch={};

    if ( placeChangeResult) {
      address_text = BaiduSearch.getAddressFromResult(placeChangeResult.addressComponents);

      const {point:{lat,lng}} = placeChangeResult;

      const bounds= isInitialSearch?this.getViewportFromLocation(map, lng, lat):this.getSearchViewportFromLocation(map, lng, lat);

      geolocation = {
        lat,
        lng,
        bounds,
        _type: AddressType.Generic
      };

      if(clicked){
        locationToPatch.Center = {
          lat: geolocation.lat,
          lng: geolocation.lng
        };
        geolocation._type = AddressType.Fixed;
      }


    } else {
      address_text=fallbackObj.name || "";
      Log.w("No address found for", address_text);
    }
    locationToPatch.Address = address_text;
    locationToPatch.Bounds = geolocation.bounds;

    return {
      locationToPatch,
      geolocation,
      address_text,
      searchedCountry
    }
  }

  static applyRestrictionsOnAutocomplete(autocompleteComponent,opt){

  }

  static applyEventOnAutocomplete(autocompleteComponent,event,callback){
    if(autocompleteComponent && event && callback){
      autocompleteComponent.addEventListener(event,(e)=>{
        callback(e);
      })
    }
  }

  static applyEventOnAutocompleteChangePlace(autocompleteComponent,callback){
    BaiduSearch.applyEventOnAutocomplete(autocompleteComponent,'onconfirm',callback);
  }


  static plainGeocode({coordinates,resolve}){
    new window.BMap.Geocoder().getLocation(new window.BMap.Point(coordinates.lng, coordinates.lat),(result) =>  {
      if(result){
        resolve(BaiduSearch.getAddressFromResult(result.addressComponents));
      }
    })
  }

  getLocation(location,resolve,reject,trigger){
    const map = this.provider.Map.Map;
    this.Geocoder.getLocation( location, (result) => {

      Log.l("Results", result);

      /* filter resultset in order to remove all not valid addresses */


      if ( !result) {
        // error
        reject(Errors.NO_ADDRESS_FOUND);
      } else {

        const {point:{lat,lng}} = result;

        const bounds = this.getSearchViewportFromLocation(map, lng, lat);

        let fixed_point = {
          lat,
          lng,
          bounds
        };

        trigger("change-address", BaiduSearch.getAddressFromResult(result.addressComponents), fixed_point);

        resolve({bounds,results: result});
      }
    });
  };

  getViewportFromLocation(map, lng, lat) {
    const viewport = map.getViewport([new BMap.Point(lng, lat)], {zoomFactor: -16});
    console.log("viewport: ",viewport);
    return viewport;
  }

  getSearchViewportFromLocation(map, lng, lat) {
    const viewport = map.getViewport([new BMap.Point(lng, lat)], {zoomFactor: +16});
    viewport.zoom=11;
    console.log("viewport: ",viewport);
    return viewport;
  }

  geocode(address, location, force_fixed_point,options, resolve, reject,trigger) {
    // Ask Geocoder for retrieving Geo address

    if(address) {
      this.Geocoder.getPoint(address,(point)=>{
        this.getLocation(point,resolve, reject, trigger);
      })
    }else{
      this.getLocation(new window.BMap.Point(location.lng, location.lat),resolve, reject, trigger);
    }
  }


}


export default BaiduSearch
